<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Draft Orders</h4>
                    </div>
                    <div class="page-btn d-flex">
                        <div class="tabs">
                            <a routerLink="/orders" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">All Orders</a>
                            <a routerLink="/orders/draft-order" routerLinkActive="active">Draft Order</a>
                        </div>
                        <!-- <a  *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-added ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Order</a> -->
                        <!-- *ngIf="accessControlService.canWrite('Budget')" -->
                        <ng-container *ngIf="accessControlService.canWrite('/orders/draft-order')">
                            <button class="btn btn-added" (click)="addBudget('Add')" *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">+ Order</button>
                         </ng-container>
                        <!-- <div class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Budget'" [exportApi]="getListExportApi"
                            [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>                               -->
                    </div>
                </div>
<!-- 8448215309 -->

                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                               <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true" [orderStatus]="true" [DateofPlacement]="true" [showCustomer]="true" 
                                 [ContactNumber]="true" [ContactEmail]="true"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <ng-container *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">
                                 <ng-container *ngIf="accessControlService.canWrite('/orders/draft-order')">
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container>
                                </ng-container>
                                <!-- <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a> -->
                            </div>

                        </div>

                        <app-shared-table [componentName]="'orders'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)" (reloadEvent)="reloadEvent($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div>
            </div>
        </div>
    </div>
</div>